import React, { useState } from "react";
import CalenderWeekWidget from "../calenderWeekWidget/CalenderWeekWidget";
import CalendarWeekEvents from "../calendarWidget/calendarWeekEvents/CalendarWeekEvents";
import ScrollLTR from "../../../ui/scrollLTR/ScrollLTR";
import classes from "./CalenderPageMobile.module.css";

const CalenderPageMobile = () => {

    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleDateSelect = (date) => {
        setSelectedDate(date);
    };

    return (
        <div className={classes.CalenderPageMobile}>
            <CalenderWeekWidget
                selectedDate={selectedDate}
                onDateSelect={handleDateSelect}
            />

            <div className={classes.EventsScrollWrapper}>
                <ScrollLTR height="100%" dropClass={classes.EventsScroll}>
                    <CalendarWeekEvents
                        selectedDate={selectedDate}
                        showMobileDateHeader
                    />
                </ScrollLTR>
            </div>
        </div>
    );
};

export default CalenderPageMobile;
